function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .clsEnviado-1 {\r\n        fill: #233164;\r\n      }\r\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1"
}, /*#__PURE__*/React.createElement("path", {
  className: "clsEnviado-1",
  d: "M12,.1c-.4.2-.7.7-.7,1.2v2.6h-4.4C3.1,3.8,0,7,0,10.9s3.2,6.5,3.9,6.9c0,0,.2,0,.3,0,.4,0,.8-.4.8-.8s-.2-.6-.4-.8c-.4-.4-.9-1.1-.9-2.3,0-2.1,1.7-3.8,3.8-3.8h3.8v2.6c0,.5.3,1,.7,1.2s1,.1,1.3-.2l6.3-5.7c.3-.2.4-.6.4-.9s-.1-.7-.4-.9L13.3.3c-.4-.3-.9-.4-1.3-.2h0Z"
})));

var SvgEnviado = function SvgEnviado(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 17.9",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEnviado, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/enviado.a9aa53e8.svg";
export { ForwardRef as ReactComponent };